import { render } from "./micDetector.vue?vue&type=template&id=34746e9e&scoped=true"
import script from "./micDetector.vue?vue&type=script&lang=js"
export * from "./micDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=34746e9e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34746e9e"]])

export default __exports__